import { observer } from 'mobx-react';
import InputComponent from '../../../../component/InputComponent';
import { Col, Form, Row, Spin } from 'antd';
import { MerchantRequest } from '../../../../request/AuthRequest';
import { useState } from 'react';
import useStore from '../../../../store';

const FormComponent = observer((props) => {
	const { handleChange, onFinish, id, form } = props;
	const [stateLoading, setStateLoading] = useState(true);
	const [cityLoading, setCityLoading] = useState(true);
	const {
		AUTH: { stateList, cityList, getStateList, getCityList },
		MERCHANT: { merchantDetail },
	} = useStore();

	return (
		<Form
			id={id}
			layout="vertical"
			form={form}
			onFinish={onFinish}
			autoComplete="off"
		>
			<Row gutter={24}>
				<Col span={8}>
					<InputComponent
						required
						name="merchantName"
						label="Merchant Name"
						placeholder="Enter Merchant Name"
						onChange={handleChange}
						rules={MerchantRequest.merchantName}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						required
						name="shortName"
						label="Short Name"
						placeholder="Enter Short Name"
						onChange={handleChange}
						rules={MerchantRequest.shortName}
					/>
				</Col>
				<Col span={10}>
					<InputComponent
						required
						name="email"
						label="Email"
						placeholder="Enter Email"
						onChange={handleChange}
						rules={MerchantRequest.email}
					/>
				</Col>
				<Col span={8}>
					<InputComponent
						required
						name="phoneNo"
						label="Phone Number"
						placeholder="Enter Phone Number"
						onChange={handleChange}
						rules={MerchantRequest.phoneNo}
					/>
				</Col>
				<Col span={8}>
					<InputComponent
						required
						type="select"
						showSearch={true}
						name="eStateId"
						label="Select State"
						placeholder="Select State"
						onFocus={() =>
							stateLoading &&
							getStateList().then(() => setStateLoading(false))
						}
						notFoundContent={
							stateLoading ? (
								<Spin size="small" />
							) : (
								'No Data Found'
							)
						}
						options={{
							values: merchantDetail
								? [
										{
											eRegionId:
												merchantDetail &&
												merchantDetail.eStateId &&
												merchantDetail.eStateId,
											regionName:
												merchantDetail &&
												merchantDetail.stateName &&
												merchantDetail.stateName,
										},
									]
								: stateList,
							value_key: 'eRegionId',
							text_key: 'regionName',
						}}
						onChange={() => {
							form.resetFields(['eCityId']);
							setCityLoading(true);
							handleChange();
						}}
						rules={MerchantRequest.state}
					/>
				</Col>
				<Col span={8}>
					<InputComponent
						required
						type="select"
						showSearch={true}
						name="eCityId"
						label="Select City"
						placeholder="Select City"
						onFocus={() =>
							cityLoading &&
							getCityList(form.getFieldValue('eStateId')).then(
								() => setCityLoading(false)
							)
						}
						notFoundContent={
							cityLoading ? (
								<Spin size="small" />
							) : (
								'No Data Found'
							)
						}
						options={{
							values: merchantDetail
								? [
										{
											eRegionId:
												merchantDetail &&
												merchantDetail.eCityId &&
												merchantDetail.eCityId,
											regionName:
												merchantDetail &&
												merchantDetail.cityName &&
												merchantDetail.cityName,
										},
									]
								: cityList,
							value_key: 'eRegionId',
							text_key: 'regionName',
						}}
						onChange={handleChange}
						rules={MerchantRequest.city}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						required
						name="pinCode"
						label="Pin Code"
						placeholder="Enter Pin Code"
						onChange={handleChange}
						rules={MerchantRequest.pinCode}
					/>
				</Col>
				{id === 'AddForm' && (
					<>
						<Col span={10}>
							<InputComponent
								name="url"
								label="Merchant URL"
								placeholder="Enter Merchant URL"
								onChange={handleChange}
								rules={MerchantRequest.URL}
							/>
						</Col>
						<Col span={8}>
							<InputComponent
								name="merchantDatabase"
								label="Merchant DB Name"
								placeholder="Enter Merchant DB Name"
								onChange={handleChange}
								rules={MerchantRequest.merchantDatabase}
							/>
						</Col>
					</>
				)}
				<Col span={12}>
					<InputComponent
						required
						type={'textarea'}
						name="address"
						label="Address"
						placeholder="Enter Address"
						onChange={handleChange}
						rules={MerchantRequest.address}
					/>
				</Col>
				<Col span={12}>
					<InputComponent
						type={'textarea'}
						name="description"
						label="Description"
						placeholder="Enter Description"
						onChange={handleChange}
						rules={MerchantRequest.description}
					/>
				</Col>
			</Row>
		</Form>
	);
});

export default FormComponent;
